import { FC } from 'react';

import { RaaDialog } from 'raa-react';

const UnauthorizedDialog: FC = () => {
  return (
    <RaaDialog header="Du har blivit utloggad" ariaDescribedBy="dialog-description">
      <>
        <p id="dialog-description" className="tw-my-4">
          Om du är inaktiv en längre stund loggas du ut automatiskt. Logga in igen för att fortsätta.
        </p>
        <a href="" className="raa-link" onClick={() => window.location.reload()}>
          Logga in
        </a>
      </>
    </RaaDialog>
  );
};

export default UnauthorizedDialog;
